import { Flex } from "@chakra-ui/react";
import { useAppSelector } from "lib/redux";
import { pickBy } from "lodash";
import { isEmpty, keys } from "lodash";
import { FC, useMemo } from "react";
import { selectBio } from "./creatorCardSlice";
import { FacebookIcon } from "lib/icons/facebook";
import { TwitterIcon } from "lib/icons/twitter";
import { LinkedInIcon } from "lib/icons/linkedin";
import { InstagramIcon } from "lib/icons/instagram";
import { Field } from "./types";

const socialKeys: Partial<keyof typeof Field>[] = [
  Field.facebook,
  Field.twitter,
  Field.linkedin,
  Field.instagram,
];

const socialIcons = {
  [Field.facebook]: FacebookIcon,
  [Field.twitter]: TwitterIcon,
  [Field.linkedin]: LinkedInIcon,
  [Field.instagram]: InstagramIcon
};

export const CreatorCardSocial: FC = () => {
  const bio = useAppSelector(selectBio);

  const socialBio = useMemo(() => (
    pickBy(bio, (value: string, key: keyof typeof Field) => value && socialKeys.includes(key))
  ), [bio, socialKeys]);

  if (isEmpty(socialBio)) {
    return null;
  }

  return (
    <Flex gridGap="20px" pt="5px" pb="5px">
      {keys(socialBio).map((key) => {
        const Icon = socialIcons[key];

        return (
          <a key={key} rel="noopener" target="_blank" href={bio[key]} title={key}>
            <Icon boxSize="25px" color="#102542" />
          </a>
        )
      })}
    </Flex>
  )
};
